import type ExceptionTypeEnum from './enums/ExceptionTypeEnum.js';

/**
 * Custom exception.
 */
export default abstract class AbstractException extends Error {
	public abstract readonly exceptionType: ExceptionTypeEnum;
	public abstract override readonly name: string;
}
